export default defineNuxtPlugin(async (_nuxtApp) => {
  const config = useRuntimeConfig();
  if (!config?.public?.isMain) return;
  if (globalConfig().faqs.length < 1) {
    globalConfig().setFaqs(await useGetFAQs());
  }
});
